// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partner-box[data-v-580eab93] {\n  width: 150px;\n  max-height: 55px;\n  border: 0.602261px solid #BED1DA;\n  border-radius: 6.02261px;\n}\n.selected[data-v-580eab93] {\n  border: 1px solid #abc74a;\n  border-radius: 6.02261px;\n}", ""]);
// Exports
module.exports = exports;
